import React, { useEffect } from 'react';
import '../App.css';
import './contact2.css';
import SEO from '../SEO';
import Crow from '../images/crow.mp4'; 
import ContactForm from './ContactForm.js'
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import Footer from './footer.js'
import { useScrollBehavior } from './useScrollBehavior.js';

const Contact2 = () => {

    useScrollBehavior();

    const title = "Contact Yokai Software | Web Design, Development, SEO, and App Solutions";
    const description = "Contact Yokai Software to discuss web design, web development, SEO, app development, and full-stack digital solutions for your business.";
    const canonical = "https://yokaisoftware.com/contact2";
    const image = "https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png";

    const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://yokaisoftware.com/#organization",
      name: "Yokai Software",
      url: "https://yokaisoftware.com/",
      logo: "https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png",
      email: "yokaisoftware66@gmail.com",
      telephone: "+1-941-613-4645",
      description:
        "Yokai Software provides web design, web development, SEO, app development, and full-stack digital solutions for businesses."
    },
    {
      "@type": "ContactPage",
      "@id": "https://yokaisoftware.com/contact2#webpage",
      url: "https://yokaisoftware.com/contact2",
      name: "Contact Yokai Software | Web Design, Development, SEO, and App Solutions",
      description:
        "Contact Yokai Software to discuss web design, web development, SEO, app development, and full-stack digital solutions for your business.",
      isPartOf: {
        "@id": "https://yokaisoftware.com/#website"
      },
      about: {
        "@id": "https://yokaisoftware.com/#organization"
      }
    }
  ]
};  

    useEffect(() => {
        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);
      }, []); // Empty dependency array ensures this effect runs only once
    

    return (
        <div id='contact2_div1'>
            <SEO
                title={title}
                description={description}
                canonical={canonical}
                image={image}
                schema={schema}
            />
            <div className='module_service_contact2' id='contact2_moduleOne'>
                <video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
                    <source src={Crow} type="video/mp4" fetchpriority="high"/>
                        Your browser does not support the video tag.
                </video>
            <div id='contact2_head'>
                <h1>Contact Us</h1>
                 <h2>And Let's Get Started!</h2>
            </div>
            
            </div>
             <div className='module_service_contact2' id='contact2_moduleTwo'>
                 <div id='contact2_div4'>
                    <div id='contactform2_div'>
                        <ContactForm/>
                    </div>
                </div>
                
                <div id='contact2_div5'>
                    <div id='contact2_subheading' className="outlined-text2">
                        <h1>Let's Build Something Together</h1>
                    </div>
                    <div id='contact2_div3'>	    
                        <h2>Whether you're curious about our services, ready to start a 
                            new project, or exploring partnership opportunities, we'd love to 
                            connect. Tell us what's on your mind; we're here to listen and 
                            help turn your ideas into reality.
                        </h2>
                    </div>
                    <div id='contact2_heading'>
                        <h1>Or Reach Us At</h1>
                       
                    </div>
                     <div id='contact2_div2'>
                        <p>contact@yokaisoftware.com</p>
                        <p id='cont_number2'>941-613-4645</p>
                    </div>
                    <div>
                        <div id="social2-icons2">
                            <a id='fafacebook' href="https://www.facebook.com/profile.php?id=61559579340148&mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                                <FaFacebook size={50} className="facebook" />
                            </a>
                            <a href="https://www.instagram.com/yokaisoftware?igsh=MTBjbWhiM294NXNxbA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer">
                                <FaInstagram size={50} className="instagram" />
                            </a>
                            <a href="https://www.linkedin.com/company/yokai-software-and-web-development/about/" target="_blank" rel="noopener noreferrer">
                                <FaLinkedin size={50} className="linkedin" />
                            </a>
                        </div>
                    </div>
                </div> 
             </div>
            
            <Footer/>
        </div>
    );
};

export default Contact2;
